import React from 'react';

const FirmaDigitalConvenios = () => {
    return (
        <div className="container mt-4">
            <h1>Firma Digital de Convenios</h1>
            <p>Módulo en desarrollo...</p>
        </div>
    );
};

export default FirmaDigitalConvenios;
